import React, { useEffect, useRef, useState } from "react";
import { getEvidenceReportMetrics } from "../../../../api";
import { Card } from "@mui/material";
import { Divider } from "@monolith-forensics/monolith-ui";
import DropDownSelector from "../../../../components/DropDownSelector";
import Loader from "../../../../components/Loader";
import DefaultPieChart from "../DefaultPieChart";
import DefaultTextChart from "../DefaultTextChart";

const views = [
  {
    text: "Charts",
    value: 0,
  },
  {
    text: "Text",
    value: 1,
  },
];

const EvidenceReportComposition = ({ reportInfo }) => {
  const [metrics, setMetrics] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [currentView, setCurrentView] = useState(0);

  useEffect(() => {
    getEvidenceReportMetrics({
      ...reportInfo.report_parameters,
      dimension: "composition",
    }).then((result) => {
      setMetrics(result);
      setIsLoading(false);
    });
  }, []);

  return (
    <Card
      style={{
        padding: "20px",
        marginBottom: "20px",
        height: "350px",
      }}
    >
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            style={{
              fontSize: "larger",
            }}
          >
            Evidence Composition
          </div>
          <div style={{ display: "flex" }}>
            <DropDownSelector
              items={views}
              useSelectMode={true}
              selectedItem={currentView}
              displayExpr="text"
              variant="contained"
              onSelect={(item) => {
                setCurrentView(item.value);
              }}
            />
          </div>
        </div>
        <Divider style={{ margin: "16px 0" }} />
        {isLoading && (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Loader />
          </div>
        )}
        {!isLoading && currentView === 0 && (
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <DefaultPieChart
              data={metrics.type_comp}
              title="Evidence Types"
              valueExpr="type_name"
            />
            <DefaultPieChart
              data={metrics.brand_comp}
              title="Evidence Brands"
              valueExpr="brand_name"
            />
            <DefaultPieChart
              data={metrics.progress_comp}
              title="Evidence Progress"
              valueExpr="progress_name"
            />
            <DefaultPieChart
              data={metrics.software_comp}
              title="Software Used"
              valueExpr="software_name"
            />
          </div>
        )}
        {!isLoading && currentView === 1 && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              userSelect: "text",
            }}
          >
            <DefaultTextChart
              data={metrics.type_comp}
              title="Evidence Types"
              valueExpr="type_name"
            />
            <DefaultTextChart
              data={metrics.brand_comp}
              title="Evidence Brands"
              valueExpr="brand_name"
            />
            <DefaultTextChart
              data={metrics.progress_comp}
              title="Evidence Progress"
              valueExpr="progress_name"
            />
            <DefaultTextChart
              data={metrics.software_comp}
              title="Software Used"
              valueExpr="software_name"
            />
          </div>
        )}
      </div>
    </Card>
  );
};

export default EvidenceReportComposition;
